var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modules-container",staticStyle:{"min-height":"450px","height":"45vh","width":"100%"},attrs:{"id":"relaysAverageChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }